export default __webpack_public_path__ + "static/Intro_logos-edc6c3a2d4e41e7c878320d8b8053f4e.svg";